import ProductionIcon from 'assets/left_navbar_icons/production.svg?react';
import invoicesRoutes from './Invoices';
import tasksRoutes from './Tasks';
import workOrdersRoutes from './WorkOrders';
import applicationsRoutes from './Applications';
import plansRoutes from './Plans';
import recommendationsRoutes from './Recommendations';

const routes = [
  {
    id: 'production',
    key: 'production',
    label: 'Production',
    path: 'production',
    exact: true,
    secure: true,
    disabled: false,
    icon: ProductionIcon,
    nav: 'leftNav',
    subRoutes: [
      ...plansRoutes.navRoutes,
      ...recommendationsRoutes.navRoutes,
      ...tasksRoutes.navRoutes,
      ...workOrdersRoutes.navRoutes,
      ...applicationsRoutes.navRoutes,
      ...invoicesRoutes.navRoutes
    ]
  },
  ...plansRoutes.allRoutes,
  ...recommendationsRoutes.allRoutes,
  ...tasksRoutes.allRoutes,
  ...workOrdersRoutes.allRoutes,
  ...applicationsRoutes.allRoutes,
  ...invoicesRoutes.allRoutes
];

export default routes;
